const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const STEPS = [
  "Küldjön egy fotót a rossz kanapéról (űrlapon vagy e-mailben).",
  "Adunk egy korrekt árat rejtett költségek nélkül.",
  "Eljövünk, kihozzuk és felpakoljuk!",
];

const BORDERS = ["md:pr-8 md:border-r-2", "md:px-8 md:border-r-2", "md:pl-8"];

export const Marquee = () => {
  const items = ["LEHOZZUK BÁRHONNAN (AKÁR 4. EMELETRŐL LIFT NÉLKÜL)", "BUDAPEST ÉS 30 KM-ES KÖRZETE", "ELSZÁLLÍTÁS AKÁR 24 ÓRÁN BELÜL"];
  const loop = [...items, ...items];
  return (
    <div data-testid="badge-marquee" className="bg-signal text-ink py-5 overflow-hidden border-y-2 border-ink">
      <div className="mq mo text-xl">
        {loop.map((t, i) => (
          <span key={i} className="flex"><span className="px-6">{t}</span><span className="px-6" aria-hidden="true">■</span></span>
        ))}
      </div>
    </div>
  );
};

export const Steps = () => (
  <section id="lepesek" data-testid="steps-section" className="bg-transport text-white py-24 md:py-32 d3-drift">
    <div className="px-6">
      <h2 className="mo mb-12">3 Egyszerű Lépés</h2>
      <div className="grid md:grid-cols-3 border-t-2 border-white">
        {STEPS.map((text, i) => (
          <div key={i} data-testid={`step-${i + 1}`} className={`py-8 border-white ${BORDERS[i]}`}>
            <span className="big mo" aria-label={`${i + 1}.`}>
              <span className="odo" aria-hidden="true">
                <span className="reel" style={{ "--d": i + 1 }}>
                  {DIGITS.map((d) => <span key={d} className="block">{d}</span>)}
                </span>
              </span>
            </span>
            <p className="mt-4 font-bold">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
